import {FormikHelpers} from 'formik';
import lQs from 'qs';
import Base64 from 'base-64';
import {notify} from '@gemcook/notification';

import {RouteComponentProps} from 'react-router-dom';

import paths from '@paths';
import utils from '@utils';

export const confirmCode = async (
  value: any,
  formikAction: FormikHelpers<any>,
  props: RouteComponentProps
) => {
  try {
    const windowQs = window.location.search;
    const strQs = windowQs.slice(1);
    const parsedQs = lQs.parse(strQs);
    const username = Base64.decode(parsedQs.username);

    await utils.amplify.forgotPasswordSubmit(
      username,
      value.code,
      value.newPassword
    );

    notify('パスワード再設定が完了しました。ログインして下さい。', 'success');
    props.history.push(paths.signIn.main);
  } catch (err) {
    console.error(err);
    switch (err.code) {
      case 'ExpiredCodeException': {
        notify(
          '認証コードが期限切れになっています。再度パスワード再設定を行って下さい。',
          'error'
        );
        break;
      }
      default: {
        notify('パスワード再設定に失敗しました', 'error');
      }
    }
  } finally {
    formikAction.setSubmitting(false);
  }
};
